import AccessLogCheckbox from './AccessLogCheckbox';

export default AccessLogCheckbox;
